<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form (ngSubmit)="save()" *ngIf="editForm" [formGroup]="editForm" class="dialog-form" name="editForm">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4 id="myProjectLabel">{{ 'project.home.createOrEditFolderLabel' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <winde-validation-alert
                [(showAlert)]="showFormValidationAlert"
                [messageObservable]="alertMessageSubject.asObservable()"
        ></winde-validation-alert>

        <div class="form-group">
            <label class="form-control-label" for="field_name">{{ 'project.name' | translate }}</label>
            <input class="form-control" formControlName="name" id="field_name" maxlength="250" required type="text"/>
        </div>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button type="submit" windeGreen>
            <sui-svg-icon icon="save"/>
            {{ 'entity.action.save' | translate }}
        </button>
    </div>
</form>
